export const sectionLabelSx = {
  fontSize: 10,
  fontWeight: 700,
  letterSpacing: "0.07em",
  textTransform: "uppercase" as const,
  color: "#797979",
  mb: "7px"
} as const;

export const fieldLabelSx = {
  display: "block" as const,
  fontSize: 12,
  fontWeight: 500,
  color: "#5d7782",
  mb: "4px"
};

export const fieldInputSx = {
  "& .MuiOutlinedInput-root": {
    height: 36,
    borderRadius: "6px",
    fontSize: 13,
    bgcolor: "#fff",
    "& fieldset": { borderColor: "#7b92a9" },
    "&:hover fieldset": { borderColor: "#7b92a9" },
    "&.Mui-focused fieldset": { borderWidth: 1, borderColor: "#071f35" }
  },
  "& .MuiOutlinedInput-input": { py: 0, px: "10px", fontSize: 13, lineHeight: 1.43 }
};

export const btnSx = {
  height: 30,
  borderRadius: "100px",
  border: `1px solid ${"#dbe8f5"}`,
  bgcolor: "#fff",
  color: "#071f35",
  px: "13px",
  fontSize: 12,
  fontWeight: 500,
  textTransform: "none" as const,
  boxShadow: "none",
  "&:hover": { bgcolor: "#f6f8fc", borderColor: "#dbe8f5", boxShadow: "none" }
};

export const btnPrimarySx = {
  ...btnSx,
  bgcolor: "#071f35",
  borderColor: "#071f35",
  color: "#fff",
  "&:hover": { bgcolor: "#0a3142", borderColor: "#0a3142", boxShadow: "none" }
};

export const btnGhostSx = {
  ...btnSx,
  border: "1px solid transparent",
  bgcolor: "transparent",
  color: "#5d7782",
  "&:hover": { bgcolor: "#f6f8fc", color: "#071f35", borderColor: "transparent", boxShadow: "none" }
};

export const ibtnSx = {
  width: 30,
  height: 30,
  borderRadius: "8px",
  border: `1px solid ${"#dbe8f5"}`,
  bgcolor: "#fff",
  color: "#5d7782",
  "&:hover": { bgcolor: "#f6f8fc" },
  "&.Mui-disabled": { opacity: 0.4, bgcolor: "#fff" }
};
